// extracted by mini-css-extract-plugin
export var layoutContainer = "_dy-0";
export var layoutContainerNoRounding = "_dy-6";
export var layoutContainerOpen = "_dy-5";
export var layoutContainerResizing = "_dy-1";
export var mainContent = "_dy-2";
export var resizeDivider = "_dy-3";
export var slidePanel = "_dy-4";